export enum Environment {
    Local = "Local",
    Dev = "Dev",
    Acc = "Acc",
    Prd = "Prd"
}

export const useEnvironment = () => {
    const url = window.location.href;

    switch (true) {
        case url.includes("localhost"):
            return Environment.Local
        case url.includes("dev"):
            return Environment.Dev;
        case url.includes("acc"):
            return Environment.Acc;
        default:
            return Environment.Prd;
    }
}
